export default __webpack_public_path__ + "static/media/portal.ed2f309f.svg";